import GateResourceInstance from "../../../../resources/expapiunified/Gate.resource.js";
import { createUnifiedRestApi } from "../utils.js";
const {
  epic: gatesEpic,
  reducer: gatesReducer,
  actions: gatesActions,
  selectors,
  getDefaultReducerState: getDefaultGatesReducerState
} = createUnifiedRestApi(GateResourceInstance, "gates", (state) => state.gates).create();
const {
  selectAll: selectAllGates,
  selectById: selectGateById,
  selectGetAsyncRequest: selectGetGateAsyncRequest,
  selectCreateOrUpdateAsyncRequest: selectCreateOrUpdateGateAsyncRequest,
  selectDeleteAsyncRequest: selectDeleteGateAsyncRequest,
  selectQueryAsyncRequest: selectQueryGatesAsyncRequest
} = selectors;
const {
  getAsync: getGateAsync,
  queryAsync: queryGatesAsync,
  createOrUpdateAsync: createOrUpdateGateAsync,
  deleteAsync: deleteGateAsync,
  resetCreateOrUpdateAsync: resetCreateOrUpdateGateAsync
} = gatesActions;
const getGatesByFeatureIdAsync = (inputPayload) => queryGatesAsync({
  workspaceId: inputPayload.workspaceId,
  query: { filter: `ExperimentOperationSet/Feature/Id eq ${inputPayload.id}` }
});
export {
  createOrUpdateGateAsync,
  deleteGateAsync,
  gatesEpic,
  gatesReducer,
  getDefaultGatesReducerState,
  getGateAsync,
  getGatesByFeatureIdAsync,
  queryGatesAsync,
  resetCreateOrUpdateGateAsync,
  selectAllGates,
  selectCreateOrUpdateGateAsyncRequest,
  selectDeleteGateAsyncRequest,
  selectGateById,
  selectGetGateAsyncRequest,
  selectQueryGatesAsyncRequest
};
//# sourceMappingURL=gates.js.map
